const sysDd = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/dd/sysDd');
const sysDdtype = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/dd/sysDdtype');
const sysLog = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/sysLog/sysLog');
const sysStudent = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/sysStudent/sysStudent');
const sysStudentDo = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/sysStudentDo/sysStudentDo');
const sysMajor = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/sysMajor/sysMajor');
const sysSchool = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/sysSchool/sysSchool');
const sysExamRoom = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/sysExamRoom/sysExamRoom');
const sysStudentScore = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/sysStudentScore/sysStudentScore');
const sysStudentAdmission = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/sysStudentAdmission/sysStudentAdmission');
const sysStudentPerm = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/sysStudentPerm/sysStudentPerm');
const sysTimeSet = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/sysTimeSet/sysTimeSet');
const examRoomPlan = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/sysExamRoom/examRoomPlan');
const examRoomDoorPrint = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/sysExamRoom/examRoomDoorPrint');
const sysStudentExam = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/sysStudentExam/sysStudentExam');
const sysStudentIn = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/sysStudentIn/sysStudentIn');
const sysStudentSituation = () =>
    import(/* webpackChunkName: "examination" */'../views/examination/sysStudentSituation/sysStudentSituation');
const sysUploadFileType = () =>
  import(/* webpackChunkName: "examination" */'../views/examination/sysUploadFileType/sysUploadFileType');
const sysTicketItem = () =>
  import(/* webpackChunkName: "examination" */'../views/examination/sysTicketItem/sysTicketItem');


export default [
    {
        path: 'sysDd',
        name: 'sysDd',
        component: sysDd
    },
    {
        path: 'sysDdtype',
        name: 'sysDdtype',
        component: sysDdtype
    },
    {
        path: 'sysLog',
        name: 'sysLog',
        component: sysLog
    },
    {
        path: 'sysStudent',
        name: 'sysStudent',
        component: sysStudent
    },
    {
        path: 'sysStudentDo',
        name: 'sysStudentDo',
        component: sysStudentDo
    },
    {
        path: 'sysMajor',
        name: 'sysMajor',
        component: sysMajor
    },
    {
        path: 'sysSchool',
        name: 'sysSchool',
        component: sysSchool
    },
    {
        path: 'sysExamRoom',
        name: 'sysExamRoom',
        component: sysExamRoom
    },
    {
        path: 'sysStudentScore',
        name: 'sysStudentScore',
        component: sysStudentScore
    },
    {
        path: 'sysStudentAdmission',
        name: 'sysStudentAdmission',
        component: sysStudentAdmission
    },
    {
        path: 'sysStudentPerm',
        name: 'sysStudentPerm',
        component: sysStudentPerm
    },
    {
        path: 'sysTimeSet',
        name: 'sysTimeSet',
        component: sysTimeSet
    },
    {
        path: 'examRoomPlan',
        name: 'examRoomPlan',
        component: examRoomPlan
    },
    {
        path: 'examRoomDoorPrint',
        name: 'examRoomDoorPrint',
        component: examRoomDoorPrint
    },
    {
        path: 'sysStudentExam',
        name: 'sysStudentExam',
        component: sysStudentExam
    },
    {
        path: 'sysStudentIn',
        name: 'sysStudentIn',
        component: sysStudentIn
    },
    {
        path: 'sysStudentSituation',
        name: 'sysStudentSituation',
        component: sysStudentSituation
    },
    {
      path: 'sysUploadFileType',
      name: 'sysUploadFileType',
      component: sysUploadFileType
    },
    {
      path: 'sysTicketItem',
      name: 'sysTicketItem',
      component: sysTicketItem
    },
]
